import { createApp } from 'vue'
import App from './App.vue'
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import {
  faXTwitter,
  faFacebook,
  faInstagram,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons'
import {
  faShoppingCart,
  faMoon,
  faSun,
  faHome,
  faMailBulk,
  faEnvelope,
  faHistory,
  faDumpster,
  faTruck,
  faFileInvoiceDollar,
  faClock,
  faHammer,
  faPersonDigging,
  faCalendarDay,
  faUser,
  faBuilding,
  faPhone,
  faFax,
  faMobileAlt,
  faMapMarkerAlt,
  faBriefcase,
  faFileSignature,
  faWarning,
  faEllipsisVertical,
  faBottleWater,
  faChevronRight,
  faChevronLeft,
  faPaperPlane,
  faCirclePlus,
  faRotateRight,
  faTrowelBricks,
  faCheckCircle,
  faBan,
  faExclamationCircle,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/js/bootstrap.bundle.js' // Importer Bootstrap JS
import 'bootstrap-icons/font/bootstrap-icons.css' // Importer les icônes Bootstrap

library.add(
  faShoppingCart,
  faMoon,
  faSun,
  faHome,
  faMailBulk,
  faEnvelope,
  faEllipsisVertical,
  faXTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
  faHistory,
  faDumpster,
  faTruck,
  faFileInvoiceDollar,
  faClock,
  faHammer,
  faPersonDigging,
  faCalendarDay,
  faUser,
  faBuilding,
  faPhone,
  faFax,
  faMobileAlt,
  faMapMarkerAlt,
  faBriefcase,
  faFileSignature,
  faWarning,
  faBottleWater,
  faChevronRight,
  faChevronLeft,
  faPaperPlane,
  faCirclePlus,
  faRotateRight,
  faTrowelBricks,
  faCheckCircle,
  faBan,
  faExclamationCircle,
  faInfoCircle
)
createApp(App)
  .use(router)
  .component('fa', FontAwesomeIcon)
  .use(VueTippy)
  .mount('#app')
